import page0 from "./_0_preliminary-questions";
import page1 from "./_1_employer-information";
import page2 from "./_2_employer-point-of-contact-information";
import page3 from "./_3_agent-or-attorney-information";
import page4 from "./_4_foreign -worker-information";
import page5 from "./_5_job-opportunity-wage-information";
import page6 from "./_6_worksite-information";
import page7 from "./_7_additional-worksites";
import page8 from "./_8_other-definable-information";
import page9 from "./_9_additional-job-opportunity-information";
import page10 from "./_10_professional-recruitment-information";
import page11 from "./_11_additional-recruitment-requirements";
import page12 from "./_12_notice_of_posting";
import page13 from "./_13_employer-labor-condition-statement";
import page14 from "./_14_preparer";
import page15 from "./_15_foreign-worker-information";
import page16 from "./_16_foreign-worker-education";
import page17 from "./_17_foreign-worker-training-qualifications";
import page18 from "./_18_foreign-worker-skills";
import page19 from "./_19_foreign-worker-work-experience";
import page20 from "./_20_additional-worksite-information";
import page21 from "./_21_supplemental-information";
import page22 from "./_22_special-recruitment-college-university";
import page23 from "./_23_application-documents";

const form_meta = {
  code: "Form ETA-9089",
  name: "Permanent Employment Certification",
};

const form_nav = [
  {
    name: "Preliminary Questions",
    symbol: "list",
  },
  {
    name: "Employer Information",
    prefix: "A",
  },
  {
    name: "Employer Point-of-Contact <br/>Information",
    prefix: "B",
  },
  {
    name: "Attorney or Agent Information",
    prefix: "C",
  },
  {
    name: "Foreign Worker Information",
    prefix: "D",
  },
  {
    name: "Job Opportunity and Wage Information",
    prefix: "E",
  },
  {
    name: "Worksite Information",
    prefix: "F.a",
  },
  {
    name: "Additional Worksites",
    prefix: "F.b",
  },
  {
    name: "Other Definable Geographic Area(s)",
    prefix: "F.c",
  },
  {
    name: "Additional Job Opportunity Information and Other Requirements",
    prefix: "G",
  },
  {
    name: "Professional/Non-Professional Recruitment Information",
    prefix: "H.c",
  },
  {
    name: "Additional Recruitment Requirements for Professional Occupations",
    prefix: "H.d",
  },
  {
    name: "Notice of Posting",
    prefix: "H.e",
  },
  {
    name: "Employer Labor Condition Statements",
    prefix: "I",
  },
  {
    name: "Preparer",
    prefix: "J",
  },
  {
    name: "Appendix A.A - Foreign Worker Contact Information",
    prefix: "APX <br/>A.A",
    classes: "label-prefix-appx",
  },
  {
    name: "Appendix A.B - Foreign Worker Education",
    prefix: "APX <br/>A.B",
    classes: "label-prefix-appx",
  },
  {
    name: "Appendix A.C - Foreign Worker Training Qualifications",
    prefix: "APX <br/>A.C",
    classes: "label-prefix-appx",
  },
  {
    name: "Appendix A.D - Foreign Worker Skills",
    prefix: "APX <br/>A.D",
    classes: "label-prefix-appx",
  },
  {
    name: "Appendix A.E - Foreign Worker Work Experience",
    prefix: "APX <br/>A.E",
    classes: "label-prefix-appx",
  },
  {
    name: "Appendix B - Additional Worksite Information",
    prefix: "APX <br/>B",
    classes: "label-prefix-appx",
  },
  {
    name: "Appendix C - Supplemental Information",
    prefix: "APX <br/>C",
    classes: "label-prefix-appx",
  },
  {
    name: "Appendix D - Special Recruitment for College and University Teachers",
    prefix: "APX <br/>D",
    classes: "label-prefix-appx",
  },
  {
    name: "Application Documents",
    symbol: "upload",
  },
];

const uiSchema = [
  page0,
  page1,
  page2,
  page3,
  page4,
  page5,
  page6,
  page7,
  page8,
  page9,
  page10,
  page11,
  page12,
  page13,
  page14,
  page15,
  page16,
  page17,
  page18,
  page19,
  page20,
  page21,
  page22,
  page23,
];

export { form_meta, form_nav };

export default uiSchema;
